import { getTranslate } from '@/legacy-src/utilities/i18n'

import { type ClientType } from '../../types/ClientStateType'
import { type TherapistType } from '../../types/TherapistStateType'
import { getFullName } from '../../utilities/name'
import { type ConversationType } from './constants'
import { parseConversationUniqueName } from './parseConversationUniqueName'

const assignOtherUserToConversation = async ({
  conversation,
  isClient,
  therapists,
  clients,
  api,
}: {
  conversation: ConversationType
  isClient: boolean
  therapists: TherapistType[]
  clients: ClientType[]
  api: any
}) => {
  const { therapistUserId, clientId } = parseConversationUniqueName(conversation.uniqueName)
  const { t } = getTranslate()

  const otherUser = isClient
    ? therapists.find((therapist) => therapist.therapistUserId === therapistUserId)
    : clients.find((client) => client.clientId === clientId)

  if (otherUser) {
    conversation.otherUser = {
      name: getFullName({ person: otherUser }),
      image: 'image' in otherUser ? otherUser.image : null,
    }
  } else if (isClient) {
    conversation.otherUser = { name: t('general.unknownUser'), image: null }
  } else
    try {
      const res = await api.getClientInfo(clientId)
      const clientInfo = res.data
      conversation.otherUser = {
        name: getFullName({
          person: { firstName: clientInfo?.firstName, lastName: clientInfo?.lastName, email: clientInfo?.email },
        }),
        image: null,
      }
    } catch {
      conversation.otherUser = { name: t('general.unknownUser'), image: null }
    }
}

export default assignOtherUserToConversation
